import { Form, InputGroup } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useSelector } from "react-redux";

const Product = ({ values, handleChange, touched, errors, handleProductSelect, selectedItem }) => {
    const products = useSelector((state) => state?.enquiry?.products)

    const filterByFields = (option, props) => {
        const searchValue = props.text.toLowerCase(); // Get user input

        return (
            option.name.toLowerCase().includes(searchValue) || // Match in 'name'
            option.code.toLowerCase().includes(searchValue)    // Match in 'code'
        );
    };
    return (
        <>
            <Form.Group>
                <Form.Label className="">
                    Which service or product are you interested in?
                </Form.Label>
                <InputGroup>
                    <Typeahead
                        id="product-typeahead"
                        newSelectionPrefix="Add a new product: "
                        options={products || []}
                        placeholder="Search by Name"
                        onChange={handleProductSelect}
                        filterBy={filterByFields}
                        selected={selectedItem}
                        labelKey="name"
                        isInvalid={!!errors.product_id}
                        disabled={!products}
                        className="w-100 "
                    />
                </InputGroup>

            </Form.Group>
        </>
    )
}

export default Product;